import { getChainOptions, WalletController } from "@terra-money/wallet-controller";
import { Fee, LCDClient, MsgExecuteContract } from "@terra-money/terra.js";
import { ConnectedWallet, CreateTxFailed, Timeout, TxFailed, TxResult, TxUnspecifiedError, UserDenied } from "@terra-money/wallet-provider";
import Config from "config";
import { Chain, ContractType, GasPrice } from "interfaces";
import { getContract } from "./contract";

let instance: WalletController;

export async function initController() {
  const chainOptions = await getChainOptions();

  instance = new WalletController({
    ...chainOptions,
  });
  return instance;
}

export async function getController() {
  return instance ?? (await initController());
}

export async function depositMSTR(lcd: LCDClient, connectedWallet: ConnectedWallet, amount: string, eventId: string, gasPrice: GasPrice) {
  const msg = new MsgExecuteContract(connectedWallet.walletAddress, getContract(ContractType.MSTR, Chain.Terra), {
    transfer: {
      amount,
      recipient: getContract(ContractType.Admin, Chain.Terra),
    },
  });
  const unsignedTx = await lcd.tx.create([{ address: connectedWallet.walletAddress }], {
    msgs: [msg],
  });
  const gas = unsignedTx.auth_info.fee.gas_limit * Number(Config.TerraGasAdjusment || 1.75);
  return await connectedWallet
    .post({
      msgs: [msg],
      fee: new Fee(gas, Math.ceil(gas * gasPrice.price) + gasPrice.denom),
    })
    .then((nextTxResult: TxResult) => {
      // @ts-ignore
      return nextTxResult.msgs[0].execute_msg.transfer.amount;
    })
    .catch((error: unknown) => {
      if (error instanceof UserDenied) {
        throw new Error("User Denied");
      } else if (error instanceof CreateTxFailed) {
        throw new Error("Create Tx Failed: " + error.message);
      } else if (error instanceof TxFailed) {
        throw new Error("Tx Failed: " + error.message);
      } else if (error instanceof Timeout) {
        throw new Error("Timeout");
      } else if (error instanceof TxUnspecifiedError) {
        throw new Error("Unspecified Error: " + error.message);
      } else {
        throw new Error("Unknown Error: " + (error instanceof Error ? error.message : String(error)));
      }
    });
}

export async function depositMAG(lcd: LCDClient, connectedWallet: ConnectedWallet, amount: string, eventId: string, gasPrice: GasPrice) {
  const msg = new MsgExecuteContract(connectedWallet.walletAddress, getContract(ContractType.MAG, Chain.Terra), {
    transfer: {
      amount,
      recipient: getContract(ContractType.Admin, Chain.Terra),
    },
  });
  const unsignedTx = await lcd.tx.create([{ address: connectedWallet.walletAddress }], {
    msgs: [msg],
  });
  const gas = unsignedTx.auth_info.fee.gas_limit * Number(Config.TerraGasAdjusment || 1.75);
  return await connectedWallet
    .post({
      msgs: [msg],
      fee: new Fee(gas, Math.ceil(gas * gasPrice.price) + gasPrice.denom),
    })
    .then((nextTxResult: TxResult) => {
      // @ts-ignore
      return nextTxResult.msgs[0].execute_msg.transfer.amount;
    })
    .catch((error: unknown) => {
      if (error instanceof UserDenied) {
        throw new Error("User Denied");
      } else if (error instanceof CreateTxFailed) {
        throw new Error("Create Tx Failed: " + error.message);
      } else if (error instanceof TxFailed) {
        throw new Error("Tx Failed: " + error.message);
      } else if (error instanceof Timeout) {
        throw new Error("Timeout");
      } else if (error instanceof TxUnspecifiedError) {
        throw new Error("Unspecified Error: " + error.message);
      } else {
        throw new Error("Unknown Error: " + (error instanceof Error ? error.message : String(error)));
      }
    });
}